import { LightningProvider } from '../providers/lightningProvider';
import { AsyncAction } from '../../base-classes/asyncAction';
import { mapParamsToObject } from '../../utilities/mapParamsToObject';

export const GET_LIGHTNING = new AsyncAction('GET_LIGHTNING');

export function getLightning(...params) {
    let paramsObject = {
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        latitude: undefined,
        longitude: undefined,
        stdParameters: undefined,
        verbose: undefined,
        refresh: undefined,
        isGpsLocation: undefined,
        safetyMessage: undefined,
        shortMessage: undefined,
        distanceUnit: undefined,
        cacheDurationMilliseconds: undefined
    };
    paramsObject = mapParamsToObject(params, paramsObject);
    return {
        type: GET_LIGHTNING.base,
        payload: getLightningAsync(paramsObject)
    };
}

async function getLightningAsync({ baseUrl, authId, secret, latitude, longitude, stdParameters, verbose, refresh, isGpsLocation, safetyMessage, shortMessage, distanceUnit, cacheDurationMilliseconds }) {
    const operation = new LightningProvider(baseUrl, authId, secret);
    return await operation.getLightning(latitude, longitude, stdParameters, verbose, isGpsLocation, safetyMessage, shortMessage, refresh, distanceUnit, cacheDurationMilliseconds);
}

